const BASE = '/api/gestion/v1';
export const ENDPOINTS = {
    auth: {
        login: `${BASE}/auth/login`,
        refresh: `${BASE}/auth/refresh`,
        logout: `${BASE}/auth/logout`,
        me: `${BASE}/auth/me`,
        forgot: `${BASE}/auth/recuperar`,
        reset: `${BASE}/auth/restablecer`,
        cambiarPassword: `${BASE}/auth/cambiar-password`,
        stepUp: `${BASE}/auth/step-up`,
    },
    reservas: `${BASE}/reservas`,
    reservaPorId: (id) => `${BASE}/reservas/${id}`,
    clases: `${BASE}/clases`,
    clasePorId: (id) => `${BASE}/clases/${id}`,
    misClases: `${BASE}/clases/mis-clases`,
    marcarClaseDictada: (id) => `${BASE}/clases/${id}/dictada`,
    clientes: `${BASE}/clientes`,
    empleados: `${BASE}/empleados`,
    promotores: `${BASE}/promotores`,
    pagos: `${BASE}/pagos`,
    liquidaciones: `${BASE}/liquidaciones`,
    anticipos: `${BASE}/anticipos`,
    tarifas: `${BASE}/tarifas`,
    niveles: `${BASE}/niveles`,
    descuentos: `${BASE}/descuentos/reglas`,
    metodosPago: `${BASE}/metodos-pago`,
    sucursales: `${BASE}/sucursales`,
    usuarios: `${BASE}/usuarios`,
    grupos: `${BASE}/grupos`,
    permisos: `${BASE}/permisos`,
    dashboard: `${BASE}/dashboard/resumen`,
    dashboardPromotor: `${BASE}/dashboard/promotor`,
    health: `${BASE}/health`,
};
